import { FC, ReactNode, useState } from 'react';
import './layout.scss';
import { getversion } from '../version';
import { LoginPage } from '../pages/login';
import { getUsername } from '../services/auth.header';
import { useAuthContext } from '../services/auth.service';

/* -------------------------------------------------------------------------------- *\
|                               MenuItem
\* -------------------------------------------------------------------------------- */
interface MenuItem { path: string; label: string; }

const MENU: MenuItem[] =
[
    { path: '/batch', label: 'Batch' },
    { path: '/ssh',   label: 'SSH' },
];
/* -------------------------------------------------------------------------------- *\
|                               LayoutSite
\* -------------------------------------------------------------------------------- */
export const LayoutSite: FC<{ children?: ReactNode }> = (children) =>
{
    const version = getversion();
    const auth = useAuthContext();
    const username = getUsername();
    const [route] = useState<string>(window.location.pathname);

    /* -------------------------------------------------------------------------------- *\
    |                               isactive
    \* -------------------------------------------------------------------------------- */
    function isactive(path: string): boolean
    {
        return route === path || (path === '/batch' && route === '/');
    }

    if (!auth || !auth.token)
    {
        return <LoginPage />;
    }

    return (
        <div className="layout">
            <div className="layout__sider">
                <div className="layout__logo">
                    <a href="/"><div className="layout__logo__brand">RT</div></a>
                </div>
                <div className="layout__username" title={username}>{username}</div>
                <div className="layout__menucont">
                    <div className="layout__menu">
                        {MENU.map(item => (
                            <a key={item.path}
                               className={'layout__menu__item' + (isactive(item.path) ? ' layout__menu__item__active' : '')}
                               href={item.path}>
                                <p className="layout__menu__item__text">{item.label}</p>
                            </a>
                        ))}
                    </div>
                    <div className="layout__menu layout__menu__bottom">
                        <div className="layout__menu__item" onClick={() => auth.logout()}>
                            <p className="layout__menu__item__text">Logout</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="layout__content">
                <div className="layout__content__inner">
                    <div className="layout__page">{children.children}</div>
                </div>
                <div className="layout__footer">{version}</div>
            </div>
        </div>
    );
}
